// extracted by mini-css-extract-plugin
export default {"container":"Difficulty_container__nAkcS","easy":"Difficulty_easy__zK4Rm","medium":"Difficulty_medium__CtVcY","hard":"Difficulty_hard__zL5zF"};